import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

export type AlertSeverity = 'info' | 'success' | 'warning' | 'danger';

@Component({
  selector: 'c-alert',
  templateUrl: './c_alert_component.html',
  styleUrls: ['./c_alert_component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class c_alert_component {
  @Input() severity: AlertSeverity = 'info';
  @Input() title?: string;
  @Input() closable = false;

  @Output() close = new EventEmitter<void>();

  hidden = false;

  get icon(): string {
    switch (this.severity) {
      case 'success': return '✓';
      case 'warning': return '⚠';
      case 'danger':  return '!';
      case 'info':
      default:        return 'ⓘ';
    }
  }

  onClose(event: MouseEvent) {
    event.stopPropagation();
    this.hidden = true;
    this.close.emit();
  }
}
